import styled from '@emotion/styled';
export const PromptWrapper = styled.div `
  background: var(--player-modal-background);
  border-radius: var(--radius-5);
  color: var(--player-modal-font-color);
  display: flex;
  flex-direction: column;
  gap: 6;
  padding: var(--spacing-3); // max(var(--radius-5), 12px);
  position: relative;
  z-index: 1;
`;
export const PromptForm = styled.form `
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--spacing-4);
  margin: 0;
`;
export const Title = styled.div `
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  padding-right: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const Input = styled.input `
  background-color: color-mix(in srgb, currentColor 10%, transparent);
  border-radius: var(--player-button-border-radius);
  border: 1px solid currentColor;
  color: currentColor;
  display: block;
  outline: none;
  padding: var(--spacing-2);
  width: 100%;

  &:focus-visible {
    outline: 2px solid currentColor;
  }
`;
export const ErrorWrapper = styled.div `
  color: var(--business-crimson);
  font-size: 14px;
`;
export const HintWrapper = styled.div `
  font-size: 0.7em;
  font-weight: normal;
  margin: 0;
  color: var(--gray4);
`;
